import { useMemo } from 'react'
import { useManualAdjustmentReasonsQuery, IncrementOrDecrement } from '../../graphql'
import { ManualAdjustmentReasonNode, ReasonOption, ReasonPickerProps } from './types'

export function getReasonVariables( reasonType?: IncrementOrDecrement ) {
	if ( reasonType ) {
		if ( reasonType === IncrementOrDecrement.Increment ) {
			return { allowIncrement: true }
		} else {
			return { allowDecrement: true }
		}
	}
	return {}
}

/**
 * Reason fetching plus the `{ value, text }` option list, shared by both
 * presentation branches so the query wiring and filtering can't drift.
 */
export default function useReasonOptions( {
	reasonType,
	filterOptions,
}: Pick<ReasonPickerProps, 'reasonType' | 'filterOptions'> ) {
	const { data, loading } = useManualAdjustmentReasonsQuery( { variables: getReasonVariables( reasonType ) } )

	const options: ReasonOption[] = useMemo( () => {
		if ( !data?.manualAdjustmentReasons ) {
			return []
		}

		const newOpts: ReasonOption[] = data.manualAdjustmentReasons
			.map( ( reason ) => ( {
				value: reason?.reason ?? '',
				text: reason?.description ?? '',
			} ) )
			.filter( ( opt ) => !!opt.value )

		return filterOptions ? newOpts.filter( filterOptions ) : newOpts
	}, [ data, filterOptions ] )

	const reasons: ManualAdjustmentReasonNode[] = useMemo( () => data?.manualAdjustmentReasons ?? [], [ data ] )

	return { options, reasons, loading }
}
